<script lang="ts">
  import { Files } from "../../../utils/Constant/Constant";
  import data from "../../../Data/FileManager/FileManager.json";

</script>
<h5 class="mt-4">{Files}</h5>
<ul class="files">
    {#each data.filesData as fileItem}
        <li class="file-box">
            <div class="file-top">
                <i class="fa fa-file-{fileItem.icon}-o txt-{fileItem.color}" /><i
                    class="fa fa-ellipsis-v f-14 ellips"
                />
            </div>
            <div class="file-bottom">
                <h6>{fileItem.title}</h6>
                <p class="mb-1">{fileItem.space}</p>
                <p><b>{fileItem.detail}</b> {fileItem.time}</p>
            </div>
        </li>
    {/each}
</ul>